import type { ReactNode } from "react";
import { adminErrorMessage } from "./AdminState";
import { useApi } from "./useApi";
import { statusLabels, type RequestStatus } from "../lib/constants";

type DashboardResponse = {
  summary: Record<RequestStatus | "total" | "retention_due_soon", number>;
};

const cards: Array<{ key: RequestStatus | "total" | "retention_due_soon"; label: string }> = [
  { key: "total", label: "إجمالي الطلبات" },
  { key: "new", label: "طلبات جديدة" },
  { key: "under_review", label: "قيد المراجعة" },
  { key: "quotation_in_progress", label: "عروض قيد الإعداد" },
  { key: "report_in_progress", label: "تقارير قيد الإعداد" },
  { key: "report_approved", label: "تقارير معتمدة" },
  { key: "closed", label: "طلبات مغلقة" },
  { key: "retention_due_soon", label: "ملفات تقترب من الحذف" },
];

export function AdminDashboard() {
  const { data, error, status, loading } = useApi<DashboardResponse>("/api/admin/requests");
  const summary: Partial<DashboardResponse["summary"]> = data?.summary ?? {};

  if (loading) return <Panel title="لوحة المؤشرات">جاري التحميل...</Panel>;
  if (error) return <Panel title="لوحة المؤشرات">{adminErrorMessage(error, status)}</Panel>;
  if (!data?.summary) return <Panel title="لوحة المؤشرات">لا توجد بيانات مؤشرات متاحة.</Panel>;

  return (
    <Panel title="لوحة المؤشرات">
      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
        {cards.map((card) => (
          <div key={card.key} className="rounded-lg border border-line bg-offwhite p-5">
            <span className="text-sm font-bold text-ash">
              {card.key in statusLabels ? statusLabels[card.key as RequestStatus] : card.label}
            </span>
            <strong className="mt-3 block text-4xl font-bold text-charcoal">
              {summary[card.key] ?? 0}
            </strong>
            <p className="mt-2 text-sm text-ash">{card.label}</p>
          </div>
        ))}
      </div>
    </Panel>
  );
}

function Panel({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section className="rounded-lg border border-line bg-white p-6 shadow-card">
      <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="eyebrow">الإدارة الداخلية</p>
          <h1 className="text-3xl font-bold text-charcoal">{title}</h1>
        </div>
        <span className="status-badge status-badge-info">محمي عبر Access</span>
      </div>
      {children}
    </section>
  );
}
